import { Button, View } from "@/components/ui";
import { Navigate, useSearchParams, useNavigate } from "react-router-dom";
import { PortalHost } from "@/components/shared/portal";
import { Typography } from "@/components/shared/typography";
import { InvoiceAccountStatementPdf } from "@/containers/profile/invoices/account-statement-pdf";
import { Container } from "@/components/ui/layout";
import { Column } from "@/components/ui/layout";

export function InvoiceAccountStatementPdfPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  if (!token) {
    return <Navigate to="/" />;
  }

  return (
    <Container>
      <Column>
        <View className="mb-4 mt-10">
          <Button
            iconName="arrowLeft"
            variant="secondary"
            color="foreground"
            onClick={() => navigate("/")}
          >
            Back
          </Button>
        </View>
        <View className="mb-4 flex flex-row items-center justify-between gap-2">
          <View className="flex flex-row items-center gap-2 p-4 md:p-0">
            <Typography variant="label-lg">Account Statement</Typography>
          </View>
          <PortalHost name="BottomActions" />
        </View>
        <InvoiceAccountStatementPdf token={token} />
      </Column>
    </Container>
  );
}
